import {
  EMPLOYER_CONTACT_US_URL,
  SALES_PHONE_NUMBER,
} from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import { TextLink } from 'braid-design-system';
import translations from './.vocab';
import { isAnzSite, asiaSites } from 'src/App/utils/siteConfig';
import type { EmployerSiteName } from 'src/types';
import { useMelwaysLink } from '@seek/melways-react';

interface PreviewPriceInformationProps {
  site: EmployerSiteName;
}
export const PreviewPriceInformation = ({
  site,
}: PreviewPriceInformationProps) => {
  const { t } = useTranslations(translations);
  const localize = useMelwaysLink();

  if (isAnzSite(site)) {
    return t('These preview prices do not...', {
      salesContact: SALES_PHONE_NUMBER[site],
    });
  }

  if (asiaSites.includes(site)) {
    return t(
      'These preview prices do not include any discount. Please talk to your Account Manager or get in touch...',
      {
        TextLink: (children) => (
          <TextLink
            href={localize({
              path: `${EMPLOYER_CONTACT_US_URL[site]}?enquiry=general`,
            })}
          >
            {children}
          </TextLink>
        ),
      },
    );
  }
};
